import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
//mui
import {Box} from '@mui/material';
//components
import AdminHeader from './AdminHeader';
import {templateStyle} from '../Template.styles';
import AdminSidebar from './AdminSidebar';
import {ApiInstanceProvider} from '@/contexts/ApiInstanceContext';
import {adminAPI} from '@/core/api';
import {USER_TYPE} from '@/utils/enums';
import {useSignalR} from '@/signal/SignalRContext';
import * as signalR from '@microsoft/signalr';
import {useNotificationSubscription} from '@/utils/hooks';
import {addNotification, setNotifications} from '@/store/notification';

const AdminTemplate = () => {
  const {connection} = useSignalR();

  useNotificationSubscription(connection, setNotifications, addNotification, 'both');

  useEffect(() => {
    const startConnection = async () => {
      if (connection && connection.state === signalR.HubConnectionState.Disconnected) {
        try {
          await connection.start();
        } catch (err) {
          // console.error('SignalR connection failed: ', err);
        }
      }
    };

    startConnection();

    return () => {
      if (connection && connection.state === signalR.HubConnectionState.Connected) {
        connection.stop();
      }
    };
  }, [connection]);

  return (
    <ApiInstanceProvider value={{apiInstance: adminAPI, role: USER_TYPE.ADMIN}}>
      <Box>
        <AdminHeader />
        <Box sx={{...templateStyle.wrapper, background: 'var(--neutral-50)'}}>
          <Box sx={templateStyle.content}>
            <AdminSidebar />

            <Box sx={templateStyle.main}>
              <Outlet />
            </Box>
          </Box>
        </Box>
      </Box>
    </ApiInstanceProvider>
  );
};

export default AdminTemplate;
